<div class="pagetitle">
  <h2>Deleted Records</h2>
</div>
<p class="text-muted deleted-intro">Deleted partners, customers, users, projects and tags wait here. Restore one to bring it back as it was, or delete it permanently.</p>

<div class="deleted-toolbar">
  <div class="deleted-tabs" role="group" aria-label="Show">
    @for (t of tabs; track t.id) {
      <button type="button" class="deleted-tab" [class.active]="t.id === tab" [attr.aria-pressed]="t.id === tab" (click)="tab = t.id">{{ t.label }} <span class="deleted-count">{{ count(t.id) }}</span></button>
    }
  </div>
  <label class="sr-only" for="deleted-search">Search deleted records</label>
  <input id="deleted-search" type="search" class="form-control form-control-sm deleted-search" placeholder="Search by name or email" (input)="search = $any($event.target).value">
</div>

@if (loading) {
  <p class="deleted-empty text-muted">Loading...</p>
} @else if (failed) {
  <p class="deleted-empty text-danger">Couldn't load the deleted records. Reload the page to try again.</p>
} @else if (!count(tab)) {
  <div class="deleted-empty">
    <i class="fa fa-trash-o fa-2x text-muted" aria-hidden="true"></i>
    <h3>{{ empty.title }}</h3>
    <p class="text-muted">{{ empty.text }}</p>
  </div>
} @else {
  <div class="table-responsive deleted-table">
    <table class="table table-sm table-hover mb-0">
      <thead>
        <tr>
          <th scope="col" class="sort-na">Name</th>
          <th scope="col" class="sort-na deleted-when">Deleted</th>
          <th scope="col" class="sort-na deleted-by">Deleted By</th>
          <th scope="col" class="sort-na"><span class="sr-only">Actions</span></th>
        </tr>
      </thead>
      <tbody>
        @for (row of visible; track row.entity + row.record.id) {
          <tr>
            <td>
              <div class="deleted-name">@if (tab === 'all') {<span class="badge badge-light deleted-kind">{{ row.kind }}</span>} @if (row.entity === 'tags') {<span class="deleted-dot" aria-hidden="true" [style.background-color]="row.record.color"></span>} <strong>{{ row.name }}</strong></div>
              @if (row.context) {<div class="text-muted small">{{ row.context }}</div>}
              @if (row.locksUsers) {<div class="small deleted-note"><i class="fa fa-lock" aria-hidden="true"></i> Its users can't sign in while it's deleted.</div>}
            </td>
            <td>
              <div>{{ row.ago }}</div>
              <div class="text-muted small">{{ row.record.deletedAt | date:'MM/dd/yyyy, h:mm a' }}</div>
            </td>
            <td class="text-break">{{ row.record.deletedByEmail || row.record.deletedBy }}</td>
            <td class="text-right text-nowrap">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="restore(row)"><i class="fa fa-undo" aria-hidden="true"></i> Restore</button>
              <button type="button" class="btn btn-sm btn-outline-danger ml-1" title="Delete permanently" [attr.aria-label]="'Delete ' + row.name + ' permanently'" (click)="askDelete(row)"><i class="fa fa-trash" aria-hidden="true"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (!visible.length) {
      <p class="deleted-empty text-muted mb-0">No deleted records match your search.</p>
    }
  </div>
  <p class="text-muted small mt-2">{{ visible.length }} {{ visible.length === 1 ? 'record' : 'records' }}, most recently deleted first</p>
}

@if (confirming; as c) {
  <div class="modal-backdrop show"></div>
  <div class="modal d-block" role="dialog" aria-modal="true" aria-labelledby="delete-title" (keydown.escape)="confirming = null">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <h5 id="delete-title">Delete {{ c.row.name }} permanently?</h5>
          @if (c.loading) {
            <p class="text-muted">This can't be undone. Counting what else it deletes...</p>
          } @else if (c.failed) {
            <p>This can't be undone. Everything it owns is deleted with it.</p>
          } @else if (c.lines.length) {
            <p>This can't be undone. Along with the {{ c.row.kind.toLowerCase() }}, it deletes:</p>
            <ul>
              @for (line of c.lines; track line) {<li>{{ line }}</li>}
            </ul>
          } @else {
            <p>This can't be undone.</p>
          }
          <label for="confirm-name">Type <strong>{{ c.row.name }}</strong> to confirm</label>
          <input #confirmName id="confirm-name" type="text" class="form-control" autocomplete="off" (input)="c.typed = $any($event.target).value">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" (click)="confirming = null">Cancel</button>
          <button type="button" class="btn btn-danger" [disabled]="!canDelete" (click)="deletePermanently()">Delete permanently</button>
        </div>
      </div>
    </div>
  </div>
}
